var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('Header',{attrs:{"activeName":_vm.activeName}}),_c('PortalHome'),_c('Aside'),_c('Bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }